import WEEK_DAYS from 'data/weekDays';

function changeWeekDay(currentDay, changeBy) {
  const dayIndex = WEEK_DAYS.indexOf(currentDay);
  const newDayIndex = (dayIndex + changeBy) % WEEK_DAYS.length;
  return WEEK_DAYS[newDayIndex];
}

export default changeWeekDay;
